// taken from Kendo documentation: https://www.telerik.com/kendo-react-ui/components/grid/filtering/

import React from 'react'
import { GridFilterCell } from '@progress/kendo-react-grid'
import { DropDownList } from '@/components/dropDownList'
import { isDefinedAndNotEmpty } from '@/utils/isDefined'
import { DropDownFilterCell } from './index'

export default (data, props = { dataItemKey: 'value' }) => {
  return class DropDownFilterCell extends GridFilterCell {
    onValueChange = ({ value }) => {
      this.props.onChange({
        value: value === undefined || value === null ? '' : value,
        operator: value === undefined || value === null ? '' : 'eq'
      })
    }

    render () {
      const dataArray = typeof data !== 'function' ? data : undefined
      const dataSource = typeof data === 'function' ? data : undefined

      return (
        <div className={'k-filtercell' + (isDefinedAndNotEmpty(this.props.value) ? ' k-filtercell-filtered' : '')}>
          <DropDownList
            data={dataArray}
            dataSource={dataSource}
            valueField={props.dataItemKey}
            onChange={this.onValueChange}
            value={this.props.value}
            allowClear={isDefinedAndNotEmpty(this.props.value)}
            {...props}
          />
        </div>
      )
    }
  }
}

export const DropDownFilterCellLocalized = (data, propName, latinPropName, locale) => {
  const field = locale === 'ar' ? propName : latinPropName

  return DropDownFilterCell(data, field)
}



// WEBPACK FOOTER //
// ./src/components/BsrsGrid/BsrsGrid.DropDownFilterCell.js